module.exports = __webpack_public_path__ + "static/media/471c096f-859b-479d-98dd-3380c0a45fc6.8b5b70ed.JPG";